export default __webpack_public_path__ + "static/media/Resume_RevD_Web.e8129fec.pdf";